import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../components'
import { getClassName } from '../../utils'

import './banner.component.scss'

/**
 * Banner Component
 */
class Banner extends Component {

  /**
   * Render Banner Button
   * @param button
   * @param index
   */
  renderBannerButton = (button, index) => {
    const { theme, icon, label, square, hidden, disabled, loading, onClick } = button

    return (
      <Button
        key={`banner-button--${index}`}
        theme={theme}
        square={square}
        loading={loading}
        hidden={hidden}
        disabled={disabled}
        icon={icon}
        label={label}
        onClick={onClick} />
    )
  }

  /**
   * Render banner
   * @returns {*}
   */
  render () {
    const { icon, title, details, controls } = this.props

    return (
      <header
        className={getClassName('banner', [
          { condition: details, trueClassName: 'banner--detailed' },
        ])}>
        <div className='banner_inner'>
          <div className='banner_header'>
            {icon && <i className={`banner_badge ${icon}`} />}
            <div className='banner_information'>
              <h1 className='banner_title'>
                {title}
              </h1>
              {details && (
                <div className='banner_details'>{details}</div>
              )}
            </div>
          </div>
          <div className='banner_controls'>
            {(controls || []).map(this.renderBannerButton)}
          </div>
        </div>
      </header>
    )
  }
}

Banner.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  details: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  controls: PropTypes.array
}

export default Banner